@let formGroupValue = formGroup();
@let keyUsagesGroupValue = keyUsagesGroup();
@if (formGroupValue && keyUsagesGroupValue) {
  <mat-expansion-panel [expanded]="expanded()">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="key-usage__header" [formGroup]="control()">
          <div>{{title}}</div>
          <mat-checkbox type="checkbox"
            (click)="$event.stopPropagation()"
            formControlName="criticalKeyUsage">{{criticalKeyUsageLabel}}</mat-checkbox>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="key-usage__checkboxes">
        @for (keyUsage of keyUsages; track keyUsage) {
        <ng-container [formGroup]="keyUsagesGroupValue">
          <mat-checkbox type="checkbox"
          [formControlName]="keyUsage">{{usageLabels[keyUsage]}}</mat-checkbox>
        </ng-container>
        }
    </div>
  </mat-expansion-panel>
}